module.exports = __webpack_public_path__ + "img/img-89.6cd9d10e.png";